import React from 'react';

import { useAuthContext } from 'state/auth';

import { LoyaltyEndOfOffersLoggedIn } from './loyalty-end-of-offers-logged-in';
import { LoyaltyEndOfOffersLoggedOut } from './loyalty-end-of-offers-logged-out';

export const LoyaltyEndOfOffers = () => {
  const { isAuthenticated } = useAuthContext();

  return isAuthenticated() ? <LoyaltyEndOfOffersLoggedIn /> : <LoyaltyEndOfOffersLoggedOut />;
};
